  <div
    *ngIf="operation && operation?.status"
    class="chat-container"
    fxLayout="column"
    fxLayoutAlign="space-between start">

    <mat-toolbar>
      <mat-toolbar-row>
        <span>{{operation.description}}</span>
        <span class="toolbar-spacer" fxFlex="1 1 auto"></span>
        <button *ngIf="operation.status === 1 && operation.isServer && !autosendVideocallRequest" (click)="requestCall()" color="primary" class="toolbar-action" mat-mini-fab aria-label="Videochiama" aria-hidden="false">
          <mat-icon>video_call</mat-icon>
        </button>




      </mat-toolbar-row>
    </mat-toolbar>

    <div
      id="chat-container"
      (dragover)="dragHover()"
      [class.hoverContainer]="dragOver"
      class="chat-messages-container"
      fxLayout="column"
      fxLayoutAlign="space-between"
      [ngStyle]="{ height: operation.status != 1 ? '100%' : '' }"
    >
      <div class="uploadMessage">
        <div class="drop-controller"
          (fileDropped)="drop($event)"
          (drop)="dragLeave()"
          (dragleave)="dragLeave()"
          appDragDrop>
        </div>
        <div class="drop-zone" >
            <mat-icon>cloud_upload</mat-icon>
            <p>Trascina qui per inviare il tuo documento</p>
        </div>
      </div>

      <div class="chat" id="chatBox" scrollable (scrollPosition)="scrollHandler($event)">

        <mat-progress-spinner
          *ngIf="paginationLoading"
          class="small-loading"
          [diameter]="30"
          color="primary"
          mode="indeterminate">
        </mat-progress-spinner>

        <tlm-message-list
          *ngIf="!initStatus; else loading"
          (scrollBottom)="scrollBottom()"
          (setDelivery)="setDeliveryMessage($event)"
          [sendingStatus]="sending"
          [messages]="messages"
          [userId]="userId"
          [ticket]="operation">
        </tlm-message-list>
      </div>

      <ng-template #loading>
        <div class="loading-container" *ngIf="paginationLoading">
          <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
        </div>
      </ng-template>
    </div>


    <div class="input-container" *ngIf="operation.status === 1">
      <input [placeholder]="'Message' | translate" [formControl]="message" (keyup.enter)="onSend()">

      <input id="fileInput" hidden type="file" #fileInput (change)="drop($event.target.files)">

      <!-- Attache file -->
      <button *ngIf="equipment" matSuffix mat-icon-button mat-flat-button color="primary" [matMenuTriggerFor]="menu">
          <mat-icon>attach_file</mat-icon>
      </button>
      <button *ngIf="!equipment" matSuffix mat-icon-button mat-flat-button color="primary" (click)="fileInput.click()">
        <mat-icon>attach_file</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="fileInput.click()">
          <mat-icon>file_upload</mat-icon>
          <span>{{ 'Upload new resource' | translate }}</span>
        </button>
        <!-- TODO add "Upload from library" and "Send procedure" -->
        <!--<button mat-menu-item disabled (click)="sendResource()">
          <mat-icon>drive_folder_upload</mat-icon>
          <span>{{ 'Upload from library' | translate }}</span>
        </button>
        <button mat-menu-item disabled (click)="sendProcedure()">
          <mat-icon>assignment</mat-icon>
          <span>{{ 'Send procedure' | translate }}</span>
        </button>-->
      </mat-menu>

      <button
        *ngIf="!isRecording"
        matSuffix
        mat-icon-button
        mat-flat-button
        color="primary"
        (click)="startRecording()">
          <mat-icon>mic</mat-icon>
      </button>

      <button
        *ngIf="isRecording"
        class="start-button"
        matSuffix
        mat-icon-button
        mat-flat-button
        color="warn"
        (click)="abortRecording()">
          <mat-icon>close</mat-icon>
      </button>

      <div class="timer" *ngIf="isRecording"> {{audioTime$ |async}} </div>

      <button
        class="stop-button"
        *ngIf="isRecording"
        matSuffix
        mat-icon-button
        mat-flat-button
        (click)="stopRecording()">
          <mat-icon>stop</mat-icon>
      </button>
    </div>
  </div>

